import * as req from 'api/actions';
import * as c from './constant';

export const getNewTaxRevenuesList = (
  payload = { sort_by: 'desc' },
  callback
) =>
  req.list(
    c.GET_NEW_TAX_REVENUES_PERMIT,
    'api/v1/bpls/administrator/tax_revenues',
    payload,
    callback
  );

export const getSingleNewTaxRevenues = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_NEW_TAX_REVENUES_PERMIT,
    `api/v1/bpls/administrator/tax_revenues/${id}`,
    payload,
    callback
  );

export const createNewTaxRevenues = (payload, callback) =>
  req.create(
    c.CREATE_NEW_TAX_REVENUES_PERMIT,
    'api/v1/bpls/administrator/tax_revenues',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateNewTaxRevenues = (id, payload, callback) =>
  req.update(
    c.UPDATE_NEW_TAX_REVENUES_PERMIT,
    `api/v1/bpls/administrator/tax_revenues/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeNewTaxRevenues = (id, payload, callback) =>
  req.remove(
    c.REMOVE_NEW_TAX_REVENUES_PERMIT,
    `api/v1/bpls/administrator/tax_revenues/${id}`,
    payload,
    callback
  );

export const getNewTaxRevenuesTypeList = (payload, callback) =>
  req.list(
    c.GET_NEW_TAX_REVENUES_TYPE_PERMIT,
    `api/v1/bpls/administrator/common/tax_revenue_types`,
    payload,
    callback
  );

export const getCalculationsList = (id, payload, callback) =>
  req.list(
    c.GET_CALCULATIONS_PERMIT,
    `api/v1/bpls/administrator/tax_revenues/${id}/calculations`,
    payload,
    callback
  );

export const createCalculations = (id, payload, callback) =>
  req.create(
    c.CREATE_CALCULATIONS_PERMIT,
    `api/v1/bpls/administrator/tax_revenues/${id}/calculations`,
    payload,
    callback
  );

export const updateCalculations = (id, calculationsId, payload, callback) =>
  req.update(
    c.UPDATE_CALCULATIONS_PERMIT,
    `api/v1/bpls/administrator/tax_revenues/${id}/calculations/${calculationsId}`,
    payload,
    callback
  );

export const removeCalculations = (id, calculationsId, payload, callback) =>
  req.remove(
    c.REMOVE_CALCULATIONS_PERMIT,
    `api/v1/bpls/administrator/tax_revenues/${id}/calculations/${calculationsId}`,
    payload,
    callback
  );

export const getCalculationsType = (payload, callback) =>
  req.list(
    c.GET_CALCULATIONS_TYPE_PERMIT,
    `api/v1/bpls/administrator/common/calculation_types`,
    payload,
    callback
  );

export const getDetailsList = (id, calculationsId, payload, callback) =>
  req.list(
    c.GET_DETAILS_PERMIT,
    `api/v1/bpls/administrator/tax_revenues/${id}/calculations/${calculationsId}/details`,
    payload,
    callback
  );

export const createDetails = (id, calculationsId, payload, callback) =>
  req.create(
    c.CREATE_DETAILS_PERMIT,
    `api/v1/bpls/administrator/tax_revenues/${id}/calculations/${calculationsId}/details`,
    payload,
    callback
  );

export const updateDetails = (
  id,
  calculationsId,
  detailsId,
  payload,
  callback
) =>
  req.update(
    c.UPDATE_DETAILS_PERMIT,
    `api/v1/bpls/administrator/tax_revenues/${id}/calculations/${calculationsId}/details/${detailsId}`,
    payload,
    callback
  );

export const removeDetails = (
  id,
  calculationsId,
  detailsId,
  payload,
  callback
) =>
  req.remove(
    c.REMOVE_DETAILS_PERMIT,
    `api/v1/bpls/administrator/tax_revenues/${id}/calculations/${calculationsId}/details/${detailsId}`,
    payload,
    callback
  );
